/**
 * @generated SignedSource<<5adcd8bb82349f14fdbb2ab9939d6daa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageSectionSidebarParticipativeModulesList_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModule",
      "kind": "LinkedField",
      "name": "participativeModules",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ParticipativeModuleCard_participativeModule"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSidebarSectionTitle_pageSection"
    }
  ],
  "type": "PageSectionParticipativeModulesList",
  "abstractKey": null
};

node.hash = "210b159314e0fc3b47d198f617f83a7c";

module.exports = node;
